import {
    MdDashboard,
    MdImportContacts,
    MdCollectionsBookmark,
    // MdRssFeed,
    MdAssignment,
    MdAssessment,
    MdDoneAll,
    MdEvent,
    // MdHowToReg,
    MdLocalLibrary
} from "react-icons/md";

import { FaBullhorn, FaGraduationCap, FaRegUserCircle } from "react-icons/fa";
import { IoIosHelpBuoy } from "react-icons/io";

const type = window.location.pathname.includes('student') ? 'student' : 'teacher'

export const MenuData = [
    {
        label: "Dashboard",
        // icon: "/assets/images/sidebar/dashboard-icon.webp",
        icon: <MdDashboard />,
        to: `/${type}/dashboard`
    },
    {
        label: "Subjects",
        icon: <MdImportContacts />,
        // icon: "/assets/images/sidebar/subjects-icon.webp",
        to: `/${type}/subjects`
    },
    {
        label: "Library",
        icon: <MdCollectionsBookmark />,
        // icon: "/assets/images/sidebar/library-icon.webp",
        to: `/${type}/library`
    },
    {
        label: "Anouncements",
        icon: <FaBullhorn />,
        // icon: "/assets/images/sidebar/announcements-icon.webp",
        to: `/${type}/announcements`
    },
    // {
    //     label: "Forum",
    //     icon: <MdRssFeed />,
    //     // icon: "/assets/images/sidebar/forum-icon.webp",
    //     to: `/${type}/forum`
    // },
    {
        label: "Assignments",
        icon: <MdAssignment />,
        // icon: "/assets/images/sidebar/assignments-icon.webp",
        to: `/${type}/assignments`
    },
    {
        label: "Examination",
        icon: <MdAssessment />,
        // icon: "/assets/images/sidebar/examination-icon.webp",
        to: `/${type}/examination`
    },
    {
        label: "Results",
        icon: <MdDoneAll />,
        // icon: "/assets/images/sidebar/results-icon.webp",
        to: `/${type}/results`
    },
    {
        label: "My Calendar",
        icon: <MdEvent />,
        // icon: "/assets/images/sidebar/calender-icon.webp",
        to: `/${type}/calendar`
    },
    {
        label: "Contact/Support",
        icon: <IoIosHelpBuoy />,
        // icon: "/assets/images/sidebar/support-icon.webp",
        to: `/${type}/support`
    },
]

export const AdminMenuData = [
    {
        label: "Dashboard",
        // icon: "/assets/images/sidebar/dashboard-icon.webp",
        icon: <MdDashboard />,
        to: `/admin/dashboard`
    },
    {
        label: "Schools",
        icon: <FaGraduationCap />,
        // icon: "/assets/images/sidebar/subjects-icon.webp",
        to: `/admin/schools`
    },
    {
        label: "Instructors",
        icon: <FaRegUserCircle />,
        // icon: "/assets/images/sidebar/library-icon.webp",
        to: `/admin/instructors`
    },
    {
        label: "Students",
        icon: <MdLocalLibrary />,
        // icon: "/assets/images/sidebar/announcements-icon.webp",
        to: `/admin/students`
    },
    // {
    //     label: "Forum",
    //     icon: <MdRssFeed />,
    //     // icon: "/assets/images/sidebar/forum-icon.webp",
    //     to: `/admin/forum`
    // },
    {
        label: "Subjects",
        icon: <MdImportContacts />,
        // icon: "/assets/images/sidebar/assignments-icon.webp",
        to: `/admin/subjects`
    },
    {
        label: "TimeTables",
        icon: <MdAssignment />,
        // icon: "/assets/images/sidebar/examination-icon.webp",
        to: `/admin/timetables`
    },
    {
        label: "Results",
        icon: <MdDoneAll />,
        // icon: "/assets/images/sidebar/results-icon.webp",
        to: `/admin/results`
    },
    {
        label: "System Settings",
        icon: <MdAssessment />,
        // icon: "/assets/images/sidebar/calender-icon.webp",
        to: `/admin/settings`
    },
    {
        label: "Extra/Support",
        icon: <IoIosHelpBuoy />,
        // icon: "/assets/images/sidebar/support-icon.webp",
        to: `/admin/support`
    },
]